import { Container } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import CreateImpactReportForm from 'components/CreateImpactReportForm/CreateImpactReportForm';
import PageHeader from 'components/PageHeader/PageHeader';
import { useEffect, useState } from 'react';
import { getOrganizations } from 'services/organisation.service';
import { getImpactReportTemplates } from 'services/impactReportTemplate.services';
import { getImpactReportModels } from 'services/impactReportModel.services';

export default function CreateImpactReportPage() {
  const { t } = useTranslation();
  const { id } = useParams();
  const impactReportId = id || '';

  const [organisationList, setOrganisationList] = useState([]);
  useEffect(() => {
    getOrganizations().then((response) => {
      setOrganisationList(response.data);
    });
  }, []);

  const [impactReportTemplateList, setImpactReportTemplateList] = useState([]);
  useEffect(() => {
    getImpactReportTemplates().then((response) => {
      setImpactReportTemplateList(response.data);
    });
  }, []);

  const [impactReportModelList, setImpactReportModelList] = useState([]);
  useEffect(() => {
    getImpactReportModels().then((response) => {
      setImpactReportModelList(response.data);
    });
  }, []);

  return (
    <Container>
      <PageHeader
        title={id ? t('createImpactReportPage.titleModify') : t('createImpactReportPage.titleCreate')}
        hasButton={false}
        hasBackButton={true}
      />
      <CreateImpactReportForm  impactReportId={impactReportId} organisationList={organisationList}  impactReportTemplateList={impactReportTemplateList}  impactReportModelList={impactReportModelList} />
    </Container>
  );
}
